// @ts-check
import { ref, onMounted } from 'vue'
import { getRequest } from '@/utils/fetch.js'

/**
 * @import { LinkList } from './propTypes.js'
 */

/**
 * @param {String} url
 */
export const setup = url => {
  const linksByGroup = ref()
  const isPc = ref(false)
  const globalUserServiceActive = ref(false)
  const globalCompanyServiceActive = ref(false)

  const getLinkList = async () => {
    try {
      const response = await getRequest('', url, {}, { withCsrf: true })
      const links = response.data
      if (links) {
        groupLinks(/** @type {LinkList} */ (links))
      }
    } catch (_) {
      //
    }
  }

  /**
   * @param {LinkList} links
   */
  const groupLinks = links => {
    const groupLinks = {}
    links.forEach(link => {
      if (groupLinks[link.group] === undefined) {
        groupLinks[link.group] = []
      }

      groupLinks[link.group].push(link)
    })

    linksByGroup.value = groupLinks
  }

  const globalUserOpenToggle = () => {
    globalUserServiceActive.value = !globalUserServiceActive.value
  }

  const globalCompanyOpenToggle = () => {
    globalCompanyServiceActive.value = !globalCompanyServiceActive.value
  }

  onMounted(() => {
    isPc.value = !window.matchMedia('(max-width: 800px)').matches
    window.addEventListener('resize', () => {
      isPc.value = !window.matchMedia('(max-width: 800px)').matches
    })

    getLinkList()
  })

  return {
    linksByGroup,
    isPc,
    globalUserServiceActive,
    globalCompanyServiceActive,

    globalUserOpenToggle,
    globalCompanyOpenToggle,
  }
}
